<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="adaptationModal businessApplicationEdit"
      :title="businessApplication.businessApplicationID ? '编辑' : '新建'"
      width="1200px"
      @close="$reset('form')">
    <el-form 
        ref="form" 
        v-loading="contentLoading" 
        :model="businessApplication" 
        :rules="ruleValidate" 
        class="form"
        label-width="100px">
      <div class="editTitle">商务申请信息</div>
      <el-row>
        <el-col v-if="businessApplication.businessApplicationID" :span="8">
          <el-form-item label="商务编号">
            <el-input v-model="businessApplication.businessApplicationNO" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="businessApplication.customerName" readonly placeholder="请选择客户">
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectCustomerName.open()"/>
            </el-input>
            <customer-select ref="selectCustomerName" @select="selectCustomerName"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="联系人">
            <el-input v-model="businessApplication.contact" placeholder="请输入联系人姓名"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系方式">
            <el-input v-model="businessApplication.mobile" placeholder="请输入联系方式"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系人职位" prop="contactPositionId">
            <el-select v-model="businessApplication.contactPositionId" placeholder="请选择联系人职位">
              <el-option v-for="item in postList" :key="item.postID" :value="item.postID" :label="item.postName"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="付款方式" prop="paymentTypeId">
            <el-select v-model="businessApplication.paymentTypeId" placeholder="请选择付款方式">
              <el-option v-for="item in payMethods" :key="item.pkId" :value="item.pkId" :label="item.paymentTypeName"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="本次销售量">
            <el-input v-model="businessApplication.salesQuantity" placeholder="请输入本次销售量"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="年销售总量">
            <el-input v-model="businessApplication.yearSalesQuantity" placeholder="请输入年销售总量"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="有效期限">
            <el-select v-model="businessApplication.timeLimit">
              <el-option label="一次有效" :value="10"/>
              <el-option label="自定义期限" :value="20"/>
              <el-option label="永久有效" :value="30"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="businessApplication.timeLimit === 20" :span="16">
          <el-form-item label="选择期限" prop="beginEndDate">
            <el-date-picker
                v-model="businessApplication.beginEndDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="beginEndDateChange"/>
          </el-form-item>
        </el-col>
        <el-col v-if="businessApplication.businessApplicationID" :span="8">
          <el-form-item label="状态" prop="statusName">
            <el-input v-model="businessApplication.statusName" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="businessApplication.businessApplicationID" :span="8">
          <el-form-item label="制单人" prop="creatorName">
            <el-input v-model="businessApplication.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col v-if="businessApplication.businessApplicationID" :span="8">
          <el-form-item label="制单时间" prop="createdDate">
            <el-input v-model="businessApplication.createdDate" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="申请理由" prop="reason">
            <el-input v-model="businessApplication.reason" type="textarea" placeholder="请输入申请理由"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px">
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input v-model="businessApplication.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">商务申请物料</div>
      <div>
        <el-button style="float: left" type="primary" @click="$refs.selectMaterial.open('已上架')"> 添加物料</el-button>
        <el-col :span="6">
          <el-form-item label="免包装和运输费用" label-width="140px">
            <el-radio-group v-model="businessApplication.containsFee">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="!businessApplication.containsFee" :span="8" style="height: 42px">
          <el-form-item label="包装和运输费用(元)" label-width="140px" prop="packDeliveryFee">
            <el-input v-model="businessApplication.packDeliveryFee" placeholder="请输入包装和运输费用"/>
          </el-form-item>
        </el-col>
      </div>
      <el-table 
          :data="businessApplication.priceVOS" 
          border 
          stripe 
          row-key="pkid" 
          :expand-row-keys="expandRowKeys">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div style="padding-left: 47px">
              <el-table border :data="scope.row.competitorList">
                <el-table-column type="index" align="center" label="#" width="45"/>
                <el-table-column prop="brand" label="品牌" width="200">
                  <template v-slot="scope">
                    <el-input v-model="scope.row.brand" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="materialName" show-overflow-tooltip label="物料名称">
                  <template v-slot="scope">
                    <el-input v-model="scope.row.materialName" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="价格" align="center" width="100">
                  <template v-slot="scope">
                    <el-input v-model="scope.row.price" class="inputCenter" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column prop="annualSalesQuantity" label="年销售量" align="center" width="100">
                  <template v-slot="scope">
                    <el-input v-model="scope.row.annualSalesQuantity" class="inputCenter" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="70">
                  <template v-slot="scope">
                    <el-button type="danger" @click="delateHandle(scope.row, scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column type="index" align="center" label="#" width="45"/>
        <!-- <el-table-column prop="businessTypeName" label="业务类别" width="100" align="center" /> -->
        <el-table-column prop="materialNo" label="物料编号" width="160" show-overflow-tooltip/>
        <el-table-column prop="materialName" label="物料名称" show-overflow-tooltip/>
        <el-table-column prop="specification" label="规格型号" width="160" show-overflow-tooltip/>
        <el-table-column prop="materialTypeName" label="物料类型" width="120" show-overflow-tooltip/>
<!--        <el-table-column align="center" prop="unitName" label="单位" width="80"/>-->
        <el-table-column align="center" prop="standardPrice" label="标准价格" width="130"/>
        <el-table-column align="center" prop="price" label="申请价格" width="130">
          <template slot-scope="scope">
            <el-input v-model="scope.row.price" class="inputCenter" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button type="primary" @click="addCompetitors(scope.row, scope.$index)">竞品</el-button>
            <el-button type="danger" @click="businessApplication.priceVOS.splice(scope.$index, 1)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="editTitle" style="margin-top: 15px">商务申请附件</div>
      <div>
        <upload-file 
            ref="upload" 
            :auth-index="authIndex" 
            style="margin-bottom: 10px; float: left"
            @upload-success="uploadSuccess"/>
        <el-table ref="payData1" :data="businessApplication.attachments" border>
          <el-table-column type="index" align="center" label="#" width="55"/>
          <el-table-column prop="fileName" align="left" label="附件描述" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px; margin: 0 auto; text-align: center"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
              <el-button type="danger" @click="businessApplication.attachments.splice(scope.$index, 1)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <customer-select ref="selectCustomerName" @select="selectCustomerName"/>
    <material-select ref="selectMaterial" @select="selectMaterial"/>
  </el-dialog>
</template>

<script>
  import CustomerSelect from "../../information/Customer/CustomerSelect";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import UploadFile from "@/components/UploadFile.vue";

  export default {
    components: {CustomerSelect, MaterialSelect, UploadFile},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        authIndex: 192,
        businessApplication: {
          businessApplicationID: "",
          businessApplicationNO: "",
          paymentTypeId: "",
          customerID: "",
          customerName: "",
          contact: "",
          mobile: "",
          contactPositionId: "",
          timeLimit: 10,
          beginDate: "",
          endDate: "",
          reason: "",
          note: "",
          containsFee: true,
          packDeliveryFee: "",
          priceVOS: [],
          attachments: [],
          beginEndDate: [],
          salesQuantity: "",
          yearSalesQuantity: "",
        },
        payMethods: [],
        postList: [],
        isCopy: 0,
        expandRowKeys: [],
        ruleValidate: {
          paymentTypeId: {required: true, message: "请选择付款方式", trigger: "change"},
          customerName: {required: true, message: "请选择客户", trigger: "change"},
          reason: {required: true, message: "请输入申请理由", trigger: "blur"},
          beginEndDate: {required: true, message: "请选择期限", trigger: "blur"},
          packDeliveryFee: {required: true, message: "请输入包装和运输费用", trigger: "blur"},
          contactPositionId: {required: true, message: "请选择联系人职位", trigger: "blur"},
        },
      };
    },

    methods: {
      open(row, isCopy, mark) {
        this.dialogVisible = true;
        this.isCopy = isCopy;
        this.$nextTick(() => {
          this.getPaymentTypes();
          if (row) {
            if (!mark) {
              this.getData(row.businessApplicationID);
            } else {
              let options = JSON.parse(row.sDSalesOrderVO);
              this.businessApplication.priceVOS = row.materialList;
              this.businessApplication.customerID = options.customerId;
              this.businessApplication.customerName = options.customerName;
              this.businessApplication.contact = options.contact;
              this.businessApplication.mobile = options.telephone;
              this.businessApplication.paymentTypeId = options.paymentTypeId;
              this.businessApplication.priceVOS.forEach((item) => {
                item.productID = item.materialId;
                item.floatingPrice = 0;
              });
            }
          }
        });
      },

      // 付款方式
      getPaymentTypes() {
        this.$http.get("basic", "paymentTypes").then((res) => {
          if (res.success) {
            this.payMethods = res.data;
            this.getPosts();
          }
        });
      },

      // 获取详情
      getData(businessApplicationID) {
        this.contentLoading = true;
        this.$http
          .get("basic", `sd/ba/${businessApplicationID}/0`)
          .then((resp) => {
            if (resp.success) {
              this.businessApplication = resp.data;
              this.businessApplication = Object.assign(this.businessApplication,resp.data);
              if (this.businessApplication.beginDate && this.businessApplication.endDate) {
                this.businessApplication.beginEndDate = [this.businessApplication.beginDate, this.businessApplication.endDate];
              }
              if (this.isCopy) {
                this.businessApplication.businessApplicationID = "";
                this.businessApplication.submitTime = "";
                this.businessApplication.status = 2201;
              }
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 联系人职位
      getPosts() {
        this.$http.get("basic", "posts/list").then((res) => {
          if (res.success) {
            this.postList = res.data;
          }
        });
      },

      // 选择客户
      selectCustomerName(row) {
        this.businessApplication.customerID = row.customerID;
        this.businessApplication.customerName = row.customerName;
        this.businessApplication.contact = row.contact;
        this.businessApplication.mobile = row.telephone;
        this.businessApplication.contactPositionId = row.positionId;
        this.businessApplication.paymentTypeId = row.paymentTypeId ? row.paymentTypeId : "";
      },

      // 选择期限
      beginEndDateChange(val) {
        if (val) {
          this.businessApplication.beginDate = val[0];
          this.businessApplication.endDate = val[1];
        }
      },

      // 添加物料
      selectMaterial(row) {
        console.log(row);
        var result = this.businessApplication.priceVOS.some((item) => item.productID === row.materialID);
        if (result) {
          this.$confirm("物料已存在，请勿重复添加", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.businessApplication.priceVOS.push({
          businessType: row.businessType,
          businessTypeName: row.businessTypeName,
          materialTypeName: row.materialTypeName,
          materialTypeId: row.materialTypeId,
          materialTypeNo: row.materialTypeNo,
          productID: row.materialID,
          materialNo: row.materialNO,
          materialName: row.materialName,
          standardPrice: row.standardPrice,
          floatingPrice: 0,
          specification: row.specification,
          unitName: row.unitName,
          price: "",
          competitorList: [],
        });
      },

      // 添加竞品
      addCompetitors(row, index) {
        let obj = {
          rowIndex: row.rowIndex,
          brand: "",
          materialName: "",
          price: "",
          annualSalesQuantity: "",
          masterId: row.pkid,
        };
        row.competitorList.push(obj);
        this.$set(this.businessApplication.priceVOS, index, row);
        this.expandRowKeys = [row.pkid];
      },

      // 删除竞品
      delateHandle(row, index) {
        this.businessApplication.priceVOS.forEach((item, i) => {
          if (item.pkid === row.masterId) {
            item.competitorList.splice(index, 1);
            this.$set(this.businessApplication.priceVOS, i, item);
          }
        });
      },

      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.businessApplication.attachments.push(params);
        }
      },

      // 下载
      downLoad(row) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            // 校验商务申请物料
            if (!this.businessApplication.priceVOS.length) {
              this.$confirm("请添加商务申请物料", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            } else {
              let result = this.businessApplication.priceVOS.some((item) => !item.price);
              if (result) {
                this.$confirm("请输入申请价格", "错误", {
                  type: "error",
                  showCancelButton: false,
                });
                return;
              }
            }
            this.submitLoading = true;
            if (this.businessApplication.businessApplicationID) {
              this.$http
                .post("basic", "sd/ba/updatePriceApply", this.businessApplication)
                .then((resp) => {
                  if (resp.success) {
                    this.$message.success("编辑成功");
                    this.$emit("save-success");
                    this.dialogVisible = false;
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "sd/ba/insertPriceApply", this.businessApplication)
                .then((resp) => {
                  if (resp.success) {
                    this.$message.success("添加成功");
                    this.$emit("save-success");
                    this.dialogVisible = false;
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>

<style>
.businessApplicationEdit .inputCenter .el-input__inner {
  text-align: center;
}
</style>
